(() => {
  const articles = document.querySelectorAll('[data-zr-article]');
  if (!articles.length) return;

  const slugify = (value) => value
    .toLocaleLowerCase('de-DE')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 72);

  const normalizedText = (value) => value
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase('de-DE')
    .replace(/[.:\-–—]+$/g, '')
    .trim();

  const isLegacyTocHeading = (heading) => /^(inhaltsverzeichnis|inhalt|inhalte|table of contents)$/.test(
    normalizedText(heading.textContent),
  );

  const isVisuallyBlank = (element) => {
    if (!element || element.querySelector('img, video, iframe, table, ul, ol')) return false;
    return !element.textContent.replace(/\u00a0/g, ' ').trim();
  };

  const isLegacyTocBlock = (element) => {
    if (!element || element.querySelector('img, video, iframe, table')) return false;
    const links = [...element.querySelectorAll('a[href^="#"]')];
    if (links.length < 2) return false;
    const allLinks = [...element.querySelectorAll('a[href]')];
    return allLinks.length === links.length;
  };

  const removeLegacyTocs = (content) => {
    const tocMarkers = [...content.querySelectorAll('h2, h3, h4, p, strong')]
      .filter(isLegacyTocHeading);

    tocMarkers
      .filter((marker) => !tocMarkers.some((other) => other !== marker && other.contains(marker)))
      .forEach((heading) => {
        const parent = heading.parentElement;
        let candidate = heading.nextElementSibling;
        const blanks = [];

        while (candidate && isVisuallyBlank(candidate)) {
          blanks.push(candidate);
          candidate = candidate.nextElementSibling;
        }

        heading.remove();
        blanks.forEach((element) => element.remove());

        if (isLegacyTocBlock(candidate)) {
          const afterToc = candidate.nextElementSibling;
          candidate.remove();
          if (isVisuallyBlank(afterToc)) afterToc.remove();
        }

        if (parent !== content && parent?.isConnected && isVisuallyBlank(parent)) parent.remove();
      });

    // Empty legacy headings were often used as visual spacers and otherwise
    // create blank entries and duplicate rules in the generated navigation.
    content.querySelectorAll('h2, h3, h4').forEach((heading) => {
      if (!heading.textContent.replace(/\u00a0/g, ' ').trim() && !heading.querySelector('img')) heading.remove();
    });
  };

  const productEmbedCss = `
    *, *::before, *::after { box-sizing: border-box; }
    html, body { margin: 0 !important; background: transparent !important; }
    body { font-family: Helvetica, Arial, sans-serif !important; color: #4e4e4e !important; }
    .shopify-buy__product.shopify-buy__layout-horizontal {
      display: grid !important;
      grid-template-columns: 220px minmax(0, 1fr) !important;
      gap: 0 26px !important;
      width: 100% !important;
      max-width: none !important;
      margin: 0 !important;
      padding: 24px !important;
      border: 1px solid #e2e2de !important;
      border-radius: 8px !important;
      background: #fff !important;
      box-shadow: 0 14px 36px rgba(21, 21, 21, 0.06) !important;
    }
    .shopify-buy__product-img-wrapper {
      grid-column: 1 !important;
      grid-row: 1 / span 5 !important;
      width: 220px !important;
      margin: 0 !important;
    }
    .main-image-wrapper {
      position: relative !important;
      display: flex !important;
      width: 220px !important;
      height: 230px !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 0 !important;
      overflow: hidden !important;
      background: #f7f7f5 !important;
    }
    .shopify-buy__product__variant-img {
      position: static !important;
      display: block !important;
      width: 100% !important;
      height: 100% !important;
      padding: 10px !important;
      object-fit: contain !important;
    }
    .carousel-button { display: none !important; }
    .shopify-buy__carousel {
      display: flex !important;
      gap: 7px !important;
      margin: 10px 0 0 !important;
      padding: 0 !important;
    }
    .shopify-buy__carousel-item {
      width: 38px !important;
      height: 38px !important;
      margin: 0 !important;
      border: 1px solid #e2e2de !important;
      border-radius: 4px !important;
      background-size: cover !important;
    }
    .shopify-buy__carousel-item--selected { border-color: #151515 !important; }
    .shopify-buy__product > :not(.shopify-buy__product-img-wrapper) { grid-column: 2 !important; }
    .shopify-buy__product__title {
      margin: 0 0 8px !important;
      color: #151515 !important;
      font-size: 20px !important;
      font-weight: 750 !important;
      letter-spacing: -0.02em !important;
      line-height: 1.2 !important;
    }
    .shopify-buy__product__price {
      margin: 0 0 14px !important;
      color: #555 !important;
      font-size: 15px !important;
      line-height: 1.4 !important;
    }
    .shopify-buy__btn-wrapper { margin: 0 0 20px !important; }
    .shopify-buy__btn {
      width: 100% !important;
      padding: 11px 16px !important;
      border-radius: 6px !important;
      background: #151515 !important;
      color: #fff !important;
      font-size: 13px !important;
      font-weight: 750 !important;
      letter-spacing: 0.02em !important;
    }
    .shopify-buy__btn:hover, .shopify-buy__btn:focus { background: #343434 !important; }
    .shopify-buy__product-description {
      margin: 0 !important;
      color: #626262 !important;
      font-size: 12.5px !important;
      line-height: 1.52 !important;
    }
    .shopify-buy__product-description p { margin: 0 0 10px !important; }
    .shopify-buy__product-description ul {
      margin: 0 0 10px !important;
      padding-left: 18px !important;
    }
    .shopify-buy__product-description li + li { margin-top: 4px !important; }
    .shopify-buy__product-description strong { color: #303030 !important; }
    @media (max-width: 600px) {
      .shopify-buy__product.shopify-buy__layout-horizontal {
        display: block !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
      }
      .shopify-buy__product-img-wrapper,
      .main-image-wrapper { width: 100% !important; }
      .shopify-buy__product-img-wrapper { margin-bottom: 18px !important; }
      .main-image-wrapper { height: 260px !important; }
      .shopify-buy__product__title { font-size: 18px !important; }
      .shopify-buy__product-description { font-size: 12px !important; }
    }
  `;

  const styleProductEmbed = (iframe) => {
    let documentRef;
    try {
      documentRef = iframe.contentDocument;
    } catch (error) {
      return false;
    }
    if (!documentRef?.head || !documentRef.querySelector('.shopify-buy__product')) return false;

    if (iframe.__zrProductDocument !== documentRef) {
      iframe.__zrProductResizeObserver?.disconnect();
      iframe.__zrProductResizeObserver = null;
      iframe.__zrProductDocument = documentRef;
    }

    if (!documentRef.getElementById('zr-article-product-embed-styles')) {
      const style = documentRef.createElement('style');
      style.id = 'zr-article-product-embed-styles';
      style.textContent = productEmbedCss;
      documentRef.head.appendChild(style);
    }

    const syncHeight = () => {
      const height = Math.ceil(Math.max(
        documentRef.documentElement?.scrollHeight || 0,
        documentRef.body?.scrollHeight || 0,
      ));
      if (height > 0) iframe.style.height = `${height}px`;
    };
    requestAnimationFrame(() => requestAnimationFrame(syncHeight));
    window.setTimeout(syncHeight, 300);
    window.setTimeout(syncHeight, 900);

    if ('ResizeObserver' in window && !iframe.__zrProductResizeObserver) {
      const resizeObserver = new ResizeObserver(syncHeight);
      resizeObserver.observe(documentRef.documentElement);
      iframe.__zrProductResizeObserver = resizeObserver;
    }
    return true;
  };

  const initProductEmbed = (iframe) => {
    if (iframe.dataset.zrProductEmbedInitialized === 'true') return;
    iframe.dataset.zrProductEmbedInitialized = 'true';
    iframe.addEventListener('load', () => styleProductEmbed(iframe));

    let attempts = 0;
    const interval = window.setInterval(() => {
      attempts += 1;
      styleProductEmbed(iframe);
      // Shopify can replace the iframe document once more after its first render.
      // Keep checking through the complete initialization window instead of
      // stopping after the first successful style injection.
      if (!iframe.isConnected || attempts >= 120) window.clearInterval(interval);
    }, 125);
  };

  const watchProductEmbeds = (content) => {
    const initialize = (root = content) => {
      if (root.matches?.('[id^="product-component-"] iframe')) initProductEmbed(root);
      root.querySelectorAll?.('[id^="product-component-"] iframe').forEach(initProductEmbed);
    };
    initialize();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initialize(node);
      }));
    });
    observer.observe(content, { childList: true, subtree: true });
  };

  articles.forEach((article) => {
    const content = article.querySelector('[data-zr-article-content]');
    const toc = article.querySelector('[data-zr-article-toc]');
    if (!content) return;

    watchProductEmbeds(content);
    removeLegacyTocs(content);
    toc?.replaceChildren();

    content.querySelectorAll('script, style').forEach((element) => element.setAttribute('data-zr-non-reading', 'true'));

    const readingClone = content.cloneNode(true);
    readingClone.querySelectorAll('script, style, [data-zr-non-reading]').forEach((element) => element.remove());
    const wordCount = readingClone.textContent.trim().split(/\s+/).filter(Boolean).length;
    const readingMinutes = Math.max(1, Math.ceil(wordCount / 220));
    article.querySelectorAll('[data-zr-reading-time]').forEach((element) => {
      element.textContent = `${readingMinutes} Min.`;
    });

    const usedIds = new Set([...document.querySelectorAll('[id]')].map((element) => element.id));
    const headings = [...content.querySelectorAll('h2')]
      .filter((heading) => heading.textContent.replace(/\u00a0/g, ' ').trim());
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const baseId = `abschnitt-${index + 1}-${slugify(heading.textContent) || 'thema'}`;
        let candidate = baseId;
        let suffix = 2;
        while (usedIds.has(candidate)) candidate = `${baseId}-${suffix++}`;
        heading.id = candidate;
        usedIds.add(candidate);
      }
      if (toc) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        toc.appendChild(item);
      }
    });

    if (!headings.length) {
      article.querySelector('.zr-article-sidebar')?.remove();
      article.querySelector('.zr-article-layout')?.classList.add('zr-article-layout--single');
    }

    content.querySelectorAll('table').forEach((table) => {
      if (table.parentElement?.classList.contains('zr-article-table')) return;
      const existingWrapper = table.closest('.scrollable-table');
      if (existingWrapper) {
        existingWrapper.classList.add('zr-article-table');
        return;
      }
      const wrapper = document.createElement('div');
      wrapper.className = 'zr-article-table';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    content.querySelectorAll('p').forEach((paragraph) => {
      const lead = paragraph.querySelector(':scope > strong:first-child');
      if (lead && /transparenzhinweis|wichtiger hinweis|hinweis:/i.test(lead.textContent)) {
        paragraph.classList.add('zr-article-callout');
      }
      const onlyChild = paragraph.children.length === 1 ? paragraph.firstElementChild : null;
      if (onlyChild?.tagName === 'STRONG' && onlyChild.children.length === 1 && onlyChild.firstElementChild?.tagName === 'A') {
        paragraph.classList.add('zr-article-cta');
      }
    });

    const faqHeading = headings.find((heading) => /^faq\b/i.test(heading.textContent.trim()));
    if (faqHeading) {
      faqHeading.classList.add('zr-article-faq-heading');
      let sibling = faqHeading.nextElementSibling;
      while (sibling && sibling.tagName !== 'H2') {
        if (sibling.tagName === 'H3') sibling.classList.add('zr-article-faq-question');
        sibling = sibling.nextElementSibling;
      }
    }

    const progress = article.querySelector('[data-zr-article-progress]');
    const updateProgress = () => {
      if (!progress) return;
      const start = article.offsetTop;
      const distance = Math.max(1, article.offsetHeight - window.innerHeight);
      const value = Math.min(1, Math.max(0, (window.scrollY - start) / distance));
      progress.style.transform = `scaleX(${value})`;
    };
    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });

    if ('IntersectionObserver' in window && toc) {
      const tocLinks = new Map([...toc.querySelectorAll('a')].map((link) => [link.getAttribute('href')?.slice(1), link]));
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          tocLinks.forEach((link, id) => link.classList.toggle('is-active', id === entry.target.id));
        });
      }, { rootMargin: '-18% 0px -72% 0px', threshold: 0 });
      headings.forEach((heading) => observer.observe(heading));
    }
  });
})();
